import type { Table } from '@tanstack/react-table';
import { memo } from 'react';

interface TotalAndStatsProps<TData> {
  onRefresh?: () => void;
  isFetching: boolean;
  isLoading: boolean;
  totalRows: number;
  showTotal: boolean;
  table: Table<TData>;
  data: TData[];
  stats?: any;
}

const DataTableStats = <TData,>({ table, data, stats: Stats }: TotalAndStatsProps<TData>) => {
  if (!Stats) return null;

  return (
    <div className='flex items-center gap-2 rounded-lg border border-gray-6 bg-gray-1 p-4'>
      <div className='flex flex-wrap justify-start'>{Stats?.(table, data || [])}</div>
    </div>
  );
};

export default memo(DataTableStats);
